import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

const CAPACIDADES = [
  {
    n: "01",
    title: "Pensar",
    text: "Antes de crear, necesito entender qué queremos conseguir, a quién queremos mover y qué merece ser contado.",
    tags: "Estrategia · Investigación · Comportamiento del cliente · Planificación · Concepto · Customer journey",
    testId: "skill-pensar",
  },
  {
    n: "02",
    title: "Convertir",
    text: "Una idea necesita encontrar la forma adecuada para salir al mundo.",
    tags: "Copywriting · Redes sociales · Creación de contenido · Fotografía · Vídeo · Reels · Stories · Adaptación de formatos · Canva · CapCut",
    testId: "skill-convertir",
  },
  {
    n: "03",
    title: "Medir y aprender",
    text: "Publicar no termina el trabajo. Los resultados también cuentan una historia.",
    tags: "Análisis de resultados · Meta Ads · Métricas · Rendimiento de contenidos · Aprendizaje · Optimización",
    testId: "skill-medir",
  },
];

export default function Skills() {
  return (
    <section
      data-testid="skills-section"
      className="bg-mirian-wine px-6 py-28 text-mirian-cream md:px-12 md:py-40 lg:px-20"
    >
      <div className="mx-auto max-w-6xl">
        <Eyebrow index="03" label="La ejecución" dark />
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif text-4xl leading-[1.1] sm:text-5xl lg:text-6xl">
            Puedo pensarlo.
            <br />
            <span className="italic text-mirian-cream/60">También puedo hacerlo.</span>
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28">
          {CAPACIDADES.map((cap, i) => (
            <div key={cap.n}>
              <motion.div
                data-testid={cap.testId}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-15% 0px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="grid grid-cols-12 gap-6 border-t border-mirian-cream/15 py-12 md:py-16"
              >
                <span className="col-span-12 font-serif text-lg italic text-mirian-cream/45 md:col-span-1">
                  {cap.n}
                </span>
                <h3 className="col-span-12 font-serif text-3xl sm:text-4xl md:col-span-4 lg:text-5xl">
                  {cap.title}
                </h3>
                <div className="col-span-12 md:col-span-6 md:col-start-7">
                  <p className="max-w-md text-base leading-relaxed text-mirian-cream/80">
                    {cap.text}
                  </p>
                  <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, margin: "-15% 0px" }}
                    transition={{ duration: 0.8, delay: 0.45 }}
                    className="mt-6 text-xs uppercase leading-loose tracking-[0.18em] text-mirian-cream/40"
                  >
                    {cap.tags}
                  </motion.p>
                </div>
              </motion.div>
              <Reveal aria-hidden="true">
                <p aria-hidden="true" className="py-1 text-center text-mirian-cream/25">
                  {i < CAPACIDADES.length - 1 ? "↓" : "↺"}
                </p>
              </Reveal>
            </div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-16 max-w-lg text-sm leading-relaxed text-mirian-cream/50">
            Las herramientas son medios.{" "}
            <span className="text-mirian-cream/80">El criterio viene antes.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
